import HubPage from '../../components/HubPage';
export default function KnowledgeHub() { return <HubPage hubKey="knowledge" />; }
